import React, { useState, useEffect, useContext } from "react";
import { ViewContext } from "./contexts/ViewContext";
import PoiList from "./PoiList";
import StaticMap from "./StaticMap";
import { getPois } from "./utils/getPois";
import { filterPois } from "./utils/filterPois";
import { calculateDistances, sortByDistance } from "./utils/turfUtils";

export default function PoiSelect() {
    const { dispatch } = useContext(ViewContext);
    const [pois, setPois] = useState([]);
    const [coords, setCoords] = useState(null);
    useEffect(() => {
        navigator.geolocation.getCurrentPosition(function (position) {
            setCoords(position.coords);
            //setCoords({ latitude: 50.7974455, longitude: -1.0919753 });
            //setCoords({latitude: 47.0887798, longitude: 17.90556662});
            console.log(position.coords);
        });
    }, []);

    useEffect(() => {
        if (coords) {
            (async () => {
                const poisReceived = await getPois(coords);
                if (poisReceived) {
                    const filteredPois = filterPois(poisReceived);
                    const poisWithDistance = calculateDistances(
                        coords,
                        filteredPois
                    );
                    const sortedPois = sortByDistance(poisWithDistance);
                    setPois(sortedPois);
                }
            })();
        }
    }, [coords, dispatch]);

    return (
        <div>
            <StaticMap coords={coords} />
            <PoiList pois={pois} />
        </div>
    );
}
